import React from "react";
import { ChangeEvent, Fragment } from "react";
import { Prompt, RouteComponentProps } from "react-router-dom";

import { apiDelete, apiGet, apiPatch, apiPost } from "../../Api";
import { formatDateTimeLocalNumeric, formatName, formatTelephone } from "../../Utilities";
import withTitle from "../withTitle";

// import HasRight from "../HasRight";
// import Indicator from "../Indicator";
import OverflowMenuItem from "../OverflowMenuItem";
import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";

import "../../blocks.css";
import "../../icomoon.css";
// import "../../indicator.css";
// import "../../list.css";
import "../../spinner.css";
// import "../../table.css";
import "../../user.css";
import "../viewer.css";


interface IDeviceDetailsState {
    error?: string;
    isLoading: boolean;
    device?: any;

    deviceName: string;
    employeeId: string;
    nodeId: string;

    hasChanged: boolean;
    isSubmitting: boolean;
    submitError?: string;

    employees: any[];
    forceProvision: boolean;

    [name: string]: any;
}


class DeviceDetailsView extends React.Component<RouteComponentProps<any>, IDeviceDetailsState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        this.state = {
            isLoading: true,

            deviceName: "",
            employeeId: "",
            nodeId: "",

            employees: [],
            forceProvision: false,

            hasChanged: false,
            isSubmitting: false,
        };

        this.submitChanges = this.submitChanges.bind(this);
        this.cancelChanges = this.cancelChanges.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleForceProvision = this.handleForceProvision.bind(this);
    }

    public async componentDidMount() {
        const deviceId = (this.props.match && this.props.match.params.id);

        try {
            const employees = await apiGet<any[]>("employees/summary?limit=400");
            employees.sort((a, b) => formatName(a.name).localeCompare(formatName(b.name)));
            employees.unshift({ id: "", name: { first: "- Not", last: "Assigned -" } });

            if (deviceId) {
                // Load existing device
                const device = await apiGet<any>(`devices/${deviceId}`);

                this.setState({
                    device,
                    isLoading: false,

                    employees,

                    deviceName: device.name,
                    employeeId: device.employeeId || "",
                    nodeId: device.nodeId,
                });
            }
            else {
                this.setState({
                    employees,
                    isLoading: false
                });
            }
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="viewer-root">
                    <div className="spinner-center lds-dual-ring-big" />
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="viewer-root">
                    <span className="error-text">{this.state.error}</span>
                </div>
            );
        }

        return (
            <div className="viewer-root with-actionbar">
                <ViewToolbar>
                    <OverflowMenuItem>
                        <ToolbarMenuItem condition={!!this.state.device} right="device:delete">
                            <button type="button" onClick={this.handleDelete}><i className="icon-trash" /><span>Delete Device</span></button>
                        </ToolbarMenuItem>
                        <ToolbarMenuItem condition={!!this.state.device}>
                            <button type="button" onClick={this.handleForceProvision}><i className="icon-history" /><span>Save &amp; Apply Now</span></button>
                        </ToolbarMenuItem>
                    </OverflowMenuItem>
                </ViewToolbar>
                <Prompt when={this.state.hasChanged} message="Your changes will not be saved if you continue." />
                {
                    this.state.submitError ? (<div className="error-box">{this.state.submitError}</div>) : ""
                }
                <div className="column-root">
                    <section className="info-block">
                        <header>
                            <h3>Device Details</h3>
                        </header>
                        <dl className="info-list block-split-spring">
                            <dt>Name</dt>
                            <dd>
                                <input type="text" className="input-light" name="deviceName" value={this.state.deviceName} onChange={this.handleInputChanged} />
                            </dd>

                            <dt>Node ID</dt>
                            <dd>
                                <input type="number" className="input-light" name="nodeId" value={this.state.nodeId} onChange={this.handleInputChanged} min="1" max="1023" />
                            </dd>

                            {
                                this.state.device
                                    ? <Fragment>
                                        <dt>Provisioning URL</dt>
                                        <dd><code className="small-text text-wrap">https://api-global.howardhf.com:9443/api/v0.1/devices/provision/{this.state.device.id}</code></dd>

                                        <dt>Provisioning timestamp</dt>
                                        <dd>{this.state.device.provisionTimestamp ? formatDateTimeLocalNumeric(this.state.device.provisionTimestamp) : "Never"}</dd>

                                        <dt>Firmware Verison</dt>
                                        <dd>{this.state.device.softwareVersion ? this.state.device.softwareVersion : "-"}</dd>

                                        <dt>Target Firmware Verison</dt>
                                        <dd>{this.state.device.targetVersion ? this.state.device.targetVersion : "-"}</dd>
                                    </Fragment>
                                    : ""
                            }
                        </dl>
                    </section>
                    <section className="info-block">
                        <header>
                            <h3>Properties</h3>
                        </header>
                        <dl className="info-list block-split-spring">
                            <dt>Assigned Employee</dt>
                            <dd>
                                <select className="input-light" name="employeeId" value={this.state.employeeId} onChange={this.handleInputChanged}>
                                    {this.state.employees.map(a => <option key={a.id} value={a.id}>{formatName(a.name)}</option>)}
                                </select>
                            </dd>

                            {
                                this.state.device ?
                                    <Fragment>
                                        <dt>Phone Number</dt>
                                        <dd>{this.state.device.cellular ? formatTelephone(this.state.device.cellular.number) : "Unknown"}</dd>

                                        <dt>IMEI</dt>
                                        <dd>{this.state.device.cellular ? this.formatIMEI(this.state.device.cellular.imei) : "Unknown"}</dd>

                                        <dt>ICCID</dt>
                                        <dd>{this.state.device.cellular ? this.formatICCID(this.state.device.cellular.iccid) : "Unknown"}</dd>
                                    </Fragment>
                                    : ""
                            }
                        </dl>
                    </section>
                </div>
                &nbsp;
                <div className="action-panel">
                    <button className="button blue btn-confirm push-right" disabled={this.state.isSubmitting} onClick={this.submitChanges}>Save</button>
                    <button className="button blue btn-cancel" disabled={this.state.isSubmitting} onClick={this.cancelChanges}>Cancel</button>
                </div>
            </div>
        );
    }

    private async submitChanges() {
        try {
            if (this.state.device) {
                // Update existing user
                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                const update = {
                    employeeId: this.state.employeeId || "0",
                    forceProvision: this.state.forceProvision,
                    name: this.state.deviceName,
                    nodeId: this.state.nodeId,
                };

                await apiPatch(`devices/${this.state.device.id}`, update);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false
                });
            }
            else {
                // Create new device
                const creationInfo = {
                    employeeId: this.state.employeeId,
                    name: this.state.deviceName,
                    nodeId: this.state.nodeId,
                };

                this.setState({
                    isSubmitting: true,
                    submitError: undefined
                });

                await apiPost("devices", creationInfo);

                this.setState({
                    hasChanged: false,
                    isSubmitting: false
                });
            }
            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSubmitting: false,
                submitError: e.message
            });
        }
    }

    private cancelChanges() {
        this.props.history.goBack();
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            hasChanged: true,
            [name]: value
        })
    }

    private async handleDelete() {
        // TODO: Replace this with a custom modal dialog overlay
        if (!window.confirm("This device's settings will be deleted and it will no longer be able to sync data.\n\nAre you sure you wish to delete this device?")) {
            return;
        }

        try {
            this.setState({
                isSubmitting: true,
            });
            await apiDelete(`devices/${this.state.device.id}`);

            this.props.history.goBack();
        }
        catch (e) {
            this.setState({
                isSubmitting: false,
                submitError: e.message,
            });
        }
    }

    private async handleForceProvision() {
        this.setState({
            forceProvision: true
        }, () => this.submitChanges());
    }

    private formatIMEI(value: string) {
        const match = value.match(/(\d{2})(\d{6})(\d{6})(\d{1})/);
        if (!match) {
            return value;
        }

        return match.slice(1).join("-");
    }

    private formatICCID(value: string) {
        const match = value.match(/(\d{5})(\d{5})(\d{5})(\d{5})/);
        if (!match) {
            return value;
        }

        return match.slice(1).join("-");
    }
}

export default withTitle("Device Details", DeviceDetailsView);
